import React, { useState } from "react";
import { Box } from "@mui/material";
import B2BNavBar from "./components/B2BNavBar";
import HeroSection from "./components/HeroSection";
import FacePortalSection from "./components/FacePortalSection";
import MementoSection from "./components/MementoSection";
import PricingSection from "./components/PricingSection";
import FeaturesSection from "./components/FeaturesSection";
import Footer from "./components/Footer";
import DemoRequestModal from "./components/DemoRequestModal";
import { useNavigate } from "react-router-dom";

export interface ModalConfig {
  title: string;
  submitLabel: string;
  preSelectedTier: string;
}

const DEFAULT_MODAL: ModalConfig = {
  title: "Request a Demo",
  submitLabel: "Request My Demo",
  preSelectedTier: "",
};

const B2BLanding: React.FC = () => {
  const navigate = useNavigate();
  const [demoOpen, setDemoOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState<ModalConfig>(DEFAULT_MODAL);

  const navItems = [
    { label: "Features", href: "#features" },
    { label: "F.A.C.E. Portal", href: "#face" },
    { label: "Memento", href: "#memento" },
    { label: "Pricing", href: "#pricing" },
  ];

  const openModal = (config: Partial<ModalConfig> = {}) => {
    setModalConfig({ ...DEFAULT_MODAL, ...config });
    setDemoOpen(true);
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <B2BNavBar
        navItems={navItems}
        onDemoClick={() =>
          openModal({ title: "Get a Demo", submitLabel: "Request My Demo" })
        }
      />
      <HeroSection
        onPartnerClick={() =>
          openModal({
            title: "Partner with Muzukuru",
            submitLabel: "Let's Partner",
          })
        }
        onSampleClick={() => navigate("/conference-page/273/test-conference")}
      />
      <FacePortalSection />
      <MementoSection />
      <PricingSection onTierClick={openModal} />
      <FeaturesSection />
      <Footer />

      <DemoRequestModal
        open={demoOpen}
        onClose={() => setDemoOpen(false)}
        title={modalConfig.title}
        submitLabel={modalConfig.submitLabel}
        preSelectedTier={modalConfig.preSelectedTier}
      />
    </Box>
  );
};

export default B2BLanding;
